import React, { useEffect, useState, useRef } from "react";

import "../../components/extrato/Style.css"
import DescExtrato from "../../components/extrato/desc-extrato/DescExtrato"
import SelecioneLancamento from "./seleciona-lancamento/SelecioneLancamento";

import { MdOutlineWatchLater } from "react-icons/md"
import { BiChevronRight } from "react-icons/bi"
import { FaMoneyBillWave, FaGooglePlay } from "react-icons/fa"
import { RiHandbagLine, RiNetflixFill } from "react-icons/ri"
import { FiShoppingCart } from "react-icons/fi"
import api, { apiUrl } from "../../services/api";
import axios from 'axios';
import TableRows from "../TableRow/TableRows";
import { ToastContainer } from "react-toastify";
import BeatLoader from "react-spinners/BeatLoader";
import { getEntrysFromFitBank } from "../../services/entrys.service";
import { css } from "@emotion/react";

export default function () {
  const [entries, setEntries] = useState()
  const [descExtrato, setDescExtrato] = useState()
  const [loader, setLoader] = useState(false)

  const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
    margin-top: 3em;
  `;

  async function getEntry() {
    setLoader(true)
    let extratos = await getEntrysFromFitBank()
    if(extratos){
      console.log("extratos ", extratos);
      setEntries(extratos)
      setLoader(false)
    }else{
      setEntries('Não existem extratos para essa conta')
      setLoader(false)
    }
  }
  const handleOnClick = (item) => {
    setDescExtrato(item)
  }

  useEffect(() => {
    getEntry()

  }, []);

  return (
    <div className="pagina-extrato">
      <div className="container">
        <div className="extrato row">
          <div className="col-xl-6">
            <p>Extrato</p>
          </div>
        </div>

        <div className="fundo-lancamento">
          <div className="row">
            <div className="scroll col-xl-6">
              <div className="lancamento">
                <div className=" row">

                  <div>
                    <h1>Últimos Lançamentos</h1>
                  </div>

                  { entries ?
                    entries.map((item, index) =>
                      <div className="row extrato-item" key={index} onClick={() => { handleOnClick(item) }}>
                        <div className="FaMoneyBillWave col-xl-2">
                          <FaMoneyBillWave className="dinheiro" />
                        </div>

                        <div className="col-xl-5">
                          <p id="extract"></p>
                          <p><strong>{item.details.replace(/-.*/, "")}</strong></p>
                        </div>

                        <div className="deposito col-xl-3">
                          <p style={parseFloat(item.entryValue) < 0 ? { color: 'red' } : { color: 'green' }}>R$ {item.entryValue}</p>
                        </div>

                        <div className="BiChevronRight col-xl-2">
                          <BiChevronRight className="seta-esquerda" />
                        </div>
                        <hr />
                      </div>
                    )
                    :
                    <div className="loader-div">
                      <BeatLoader color={"var(--secondary-color)"} loading={loader} css={override} size={20} />
                    </div>
                  }
                </div>
              </div>
            </div>
            <div className="col-xl-6">
              <div className="visualizar-lancamento">
                <DescExtrato data={descExtrato} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
}
